import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";

class PropertyCreateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process = (): void => {
    const ownerId = parseInt(this.component.props.params.ownerId, 10);
    const selectedCompany = this.component.props.app.companies.find(company => company.id === ownerId);

    this.component.props.dispatch({
      type: Constants.PAGE_PROPERTY_CREATE_CLEAR
    });

    if (!!selectedCompany) {
      this.component.disableOwnerId = selectedCompany?.id;

      this.component.setState({
        selectedCompany: selectedCompany
      })
    }

    if (Object.keys(this.component.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdPerson = this.component.props.app.savedDataBeforeRedirecting.createdPerson;
      const createdCompany = this.component.props.app.savedDataBeforeRedirecting.statePropertyName === "owner" ? this.component.props.app.savedDataBeforeRedirecting.createdCompany : null;
      const createdAssociationOwner = this.component.props.app.savedDataBeforeRedirecting.statePropertyName === "associationOwner" ? this.component.props.app.savedDataBeforeRedirecting.createdCompany : null;

      const state = {
        ...this.component.props.app.savedDataBeforeRedirecting.propertyCreateDataToBeSaved,
        selectedPerson: !!createdPerson ? createdPerson : !!this.component.props.app.savedDataBeforeRedirecting.propertyCreateDataToBeSaved && this.component.props.app.savedDataBeforeRedirecting.propertyCreateDataToBeSaved.selectedPerson,
        selectedCompany: !!createdCompany ? createdCompany : !!this.component.props.app.savedDataBeforeRedirecting.propertyCreateDataToBeSaved && this.component.props.app.savedDataBeforeRedirecting.propertyCreateDataToBeSaved.selectedCompany,
        selectedAssociationOwner: !!createdAssociationOwner ? createdAssociationOwner : !!this.component.props.app.savedDataBeforeRedirecting.propertyCreateDataToBeSaved && this.component.props.app.savedDataBeforeRedirecting.propertyCreateDataToBeSaved.selectedAssociationOwner
      }

      this.component.setState({
        ...state
      });
    }
  }
}

export default new PropertyCreateWillMount();
